// extracted by mini-css-extract-plugin
export default {"container":"Item__container-H7drL","avatars":"Item__avatars-VSmvc","avatar":"Item__avatar-BByBQ","arrowIcon":"Item__arrowIcon-SCKhT","name":"Item__name-udWr9"};